<template>
  <div
    class="carousel"
    v-if="!!slides.length"
  >
    <div
      class="inner"
      :style="innerStyle"
    >
      <div
        :key="i"
        class="item"
        v-for="(item, i) in items"
        :style="{ width: 100 / len + '%', backgroundImage: `url(${item.src})` }"
      >
        <a
          v-if="/^https?:\/\//.test(item.href)"
          :href="item.href"
          :to="item.href"
        >
        </a>
        <router-link
          :to="item.href"
          v-else-if="item.href"
        >
        </router-link>
        <slot>
          <div v-if="item.title" class="title">{{ item.title }}</div>
        </slot>
      </div>
    </div>
    <div v-if="showSwitch" class="prev" @click="prevFn" :class="prevClass">&lt;</div>
    <div v-if="showSwitch" class="next" @click="nextFn" :class="nextClass">&gt;</div>
    <ul class="indicators" v-if="showQuota" :class="quotaClass">
      <li
        :key="n"
        v-for="n in (len - 2)"
        @click="slideToFn(n)"
        :class="{'active': cIndex === n || (cIndex === (len - 1) && n === 1)
          || (cIndex === 0 && n === len - 2)}"
      ></li>
    </ul>
  </div>
</template>

<script>
import './carousel.scss'

export default {
  name: 'carousel',
  props: {
    slides: {
      type: Array,
      required: true
    },
    interval: { // 切换时间
      type: Number,
      default: 5000
    },
    showSwitch: { // 显示切换按钮
      type: Boolean,
      default: false
    },
    showQuota: { // 显示指示符
      type: Boolean,
      default: true
    },
    quotaClass: { // 指示符的class
      type: String,
      default: '',
    },
    prevClass: { // 后退class
      type: String,
      default: '',
    },
    nextClass: { // 前进class
      type: String,
      default: '',
    }
  },
  data() {
    return {
      timer: null, // 自动播放的定时器
      cIndex: 1, // 当前显示第一张
      isResetIndex: false, // 是否为瞬间重置定位，在watch中初始化，重定位会取消transition动画
      isTransition: false, // 是否处于过度动画执行期间
      transitionTime: 500, // 过渡动画时长
    }
  },
  computed: {
    // 为实现无缝滚动，在传进来的数组首部增加末尾元素，在尾部追加首元素
    items() {
      var fImage = this.slides[0];
      var lImage = this.slides[this.slides.length - 1]
      return [lImage, ...this.slides, fImage]
    },
    len() {
      return this.items.length
    },
    innerStyle() {
      const len = this.items.length
      return {
        width: len * 100 + '%', 
        transform: `translate(-${this.cIndex * 100 / len}%)`,
        transition: this.isResetIndex ? '' : `transform ${this.transitionTime}ms`
      }
    }
  },
  methods: {
    prevFn() {
      // 动画过渡中不能切换
      if (this.isTransition) return
      this.cIndex -= 1
    },
    nextFn() {
      if (this.isTransition) return
      this.cIndex += 1
    },
    slideToFn(index) {
      this.cIndex = index
    },
    // 启动自动轮播函数
    startInterval() {
      this.timer = setInterval(() => {
        this.cIndex += 1
      }, this.interval)
    }
  },
  mounted() {
    this.startInterval()
  },
  watch: {
    // 监听cIndex的变化，当cIndex到达边界的时候进行复位
    cIndex(nIndex, oIndex) {
      const len = this.items.length
      // 如果轮播图是从最后一张切换到第一张 || 从第一张切换到最后一张 则瞬间归位
      if ((nIndex === 1 && oIndex === (len - 1)) || (oIndex === 0 && nIndex === len - 2)) {
        this.isResetIndex = true
        return
      }
      this.isResetIndex = false
      // 当动画正在过渡中时，不能进行切换轮播
      this.isTransition = true
      // 瞬间归位需要取消transition过渡
      setTimeout(() => {
        // 以下两种情况是瞬间归位时cIndex变化
        if (this.cIndex === 0) {
          this.cIndex = len - 2
        } else if (this.cIndex === (len - 1)) {
          this.cIndex = 1
        }
        // transition过渡结束，可以进行切换轮播
        this.isTransition = false 
      }, this.transitionTime)
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Carousel/Carousel.vue